import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'
// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#43A047",
        secondary: "#A0D468",
        accent: "#7CB342",
        error: "#B71C1C",
      },
      dark: {
        primary: "#2E7D32",
      },
    },
  },
}

export default new Vuetify(opts)